export default __webpack_public_path__ + "static/media/edit.5e8c4c6a.svg";